export const TOPOWEBB = 'TOPOWEBB'
export const TOPOWEBB_NEDTONAD = 'TOPOWEBB_NEDTONAD'
export const ORTOFOTO = 'ORTOFOTO'


// WEBPACK FOOTER //
// ./src/constants/basemaps.js